//#region src/brink_api_server.ts
var BrinkApiServer = /* @__PURE__ */ function(BrinkApiServer) {
	BrinkApiServer[BrinkApiServer["Sandbox"] = 1] = "Sandbox";
	BrinkApiServer[BrinkApiServer["Api"] = 101] = "Api";
	BrinkApiServer[BrinkApiServer["Api2"] = 2] = "Api2";
	BrinkApiServer[BrinkApiServer["Api3"] = 3] = "Api3";
	BrinkApiServer[BrinkApiServer["Api4"] = 4] = "Api4";
	BrinkApiServer[BrinkApiServer["Api5"] = 5] = "Api5";
	BrinkApiServer[BrinkApiServer["Api6"] = 6] = "Api6";
	BrinkApiServer[BrinkApiServer["Api7"] = 7] = "Api7";
	BrinkApiServer[BrinkApiServer["Api8"] = 8] = "Api8";
	BrinkApiServer[BrinkApiServer["Api9"] = 9] = "Api9";
	BrinkApiServer[BrinkApiServer["Api10"] = 10] = "Api10";
	BrinkApiServer[BrinkApiServer["Api11"] = 11] = "Api11";
	BrinkApiServer[BrinkApiServer["Api12"] = 12] = "Api12";
	BrinkApiServer[BrinkApiServer["Api14"] = 14] = "Api14";
	BrinkApiServer[BrinkApiServer["Api15"] = 15] = "Api15";
	BrinkApiServer[BrinkApiServer["Api19"] = 19] = "Api19";
	BrinkApiServer[BrinkApiServer["Api20"] = 20] = "Api20";
	BrinkApiServer[BrinkApiServer["Api21"] = 21] = "Api21";
	BrinkApiServer[BrinkApiServer["Api22"] = 22] = "Api22";
	BrinkApiServer[BrinkApiServer["Api23"] = 23] = "Api23";
	BrinkApiServer[BrinkApiServer["Api24"] = 24] = "Api24";
	BrinkApiServer[BrinkApiServer["Api25"] = 25] = "Api25";
	BrinkApiServer[BrinkApiServer["Api26"] = 26] = "Api26";
	BrinkApiServer[BrinkApiServer["Api27"] = 27] = "Api27";
	BrinkApiServer[BrinkApiServer["Api28"] = 28] = "Api28";
	BrinkApiServer[BrinkApiServer["Api29"] = 29] = "Api29";
	BrinkApiServer[BrinkApiServer["Api30"] = 30] = "Api30";
	BrinkApiServer[BrinkApiServer["Api31"] = 31] = "Api31";
	BrinkApiServer[BrinkApiServer["Api32"] = 32] = "Api32";
	BrinkApiServer[BrinkApiServer["Api33"] = 33] = "Api33";
	BrinkApiServer[BrinkApiServer["Api34"] = 34] = "Api34";
	BrinkApiServer[BrinkApiServer["Api35"] = 35] = "Api35";
	BrinkApiServer[BrinkApiServer["Api36"] = 36] = "Api36";
	BrinkApiServer[BrinkApiServer["Api37"] = 37] = "Api37";
	BrinkApiServer[BrinkApiServer["Api38"] = 38] = "Api38";
	BrinkApiServer[BrinkApiServer["Api39"] = 39] = "Api39";
	BrinkApiServer[BrinkApiServer["Api40"] = 40] = "Api40";
	BrinkApiServer[BrinkApiServer["Api41"] = 41] = "Api41";
	BrinkApiServer[BrinkApiServer["Api42"] = 42] = "Api42";
	BrinkApiServer[BrinkApiServer["Api43"] = 43] = "Api43";
	BrinkApiServer[BrinkApiServer["Api44"] = 44] = "Api44";
	BrinkApiServer[BrinkApiServer["Api45"] = 45] = "Api45";
	BrinkApiServer[BrinkApiServer["Api46"] = 46] = "Api46";
	BrinkApiServer[BrinkApiServer["Api47"] = 47] = "Api47";
	BrinkApiServer[BrinkApiServer["Api48"] = 48] = "Api48";
	BrinkApiServer[BrinkApiServer["Api49"] = 49] = "Api49";
	BrinkApiServer[BrinkApiServer["Api50"] = 50] = "Api50";
	BrinkApiServer[BrinkApiServer["ApiSales"] = 10001] = "ApiSales";
	BrinkApiServer[BrinkApiServer["ApiChannel"] = 10002] = "ApiChannel";
	BrinkApiServer[BrinkApiServer["ZaxbysUatLab"] = 10003] = "ZaxbysUatLab";
	BrinkApiServer[BrinkApiServer["ApiEarlyExposure"] = 10004] = "ApiEarlyExposure";
	return BrinkApiServer;
}(BrinkApiServer || {});
//#endregion
export { BrinkApiServer };

//# sourceMappingURL=brink_api_server.js.map